import React, {useMemo} from 'react';
import {BadgeProps} from './types';
import {BadgeStyletMap} from './styles';
import {Layout} from '../layout';
import {Text} from '../text';
import {useTheme} from '../../theme';

export const Badge: React.FC<BadgeProps> = ({
  content,
  size = 'Default',
  kind = 'Primary',
  round = 'false',
}) => {
  const theme = useTheme();
  const borderRadius = round ? '9999' : '4';
  const {color, typography, height, style} = useMemo(() => {
    const {color, typography, height, ...style} = BadgeStyletMap[size][kind];
    return {color, typography, height: theme.spacing[height], style};
  }, [kind, size, theme]);

  return (
    <Layout
      centered
      {...style}
      height={height}
      borderRadius={borderRadius}
      paddingHorizontal={'6'}>
      <Text textColor={color} variant={typography} align={'center'}>
        {content}
      </Text>
    </Layout>
  );
};
